import React from "react";
import {
  Box,
  Typography,
  useTheme,
} from "@mui/material";
import AuditList from "../Settings/Audits/pages/AuditList";

const AuditorAuditList = () => {
  const theme = useTheme();

  return (
    <>
      <AuditList isAuditorView={true} />
    </>
  );
};

export default AuditorAuditList;
